export const getBarColors = () => {
    return [
      "#481A6C",
      "#583083",
      "#67418E",
      "#765399",
      "#8565A4",
      "#8F60B3",
      "#946EB7",
      "#986FB0",
      "#A882BB",
      "#A082BB",
      "#B896C6",
      "#C1A9D0",
      "#C8ABD2",
      "#D8BFDD",
      "#E8D4E8",
      "#E0D4E8",
      "#F9E9F4",
      "#F0E9F4"
    ];
  };